import { endpoints, request } from '!core/api';

export const userSecuritiesAccountsServices = {
  userSecuritiesAccounts: () =>
    request.get(endpoints.chnn('wsbGetUserSecuritiesAccounts')),
  setUserSecuritiesAccountsFavourite: ({ account }) =>
    request.put(
      endpoints.chnn(
        `wsbSetUserSecuritiesAccouts?account=${account}&favorite=Y&visible=Y`,
      ),
    ),
  setUserSecuritiesAccountsVisible: ({ account, visible }) =>
    request.put(
      endpoints.chnn(
        `wsbSetUserSecuritiesAccouts?account=${account}&visible=${visible}`,
      ),
    ),
};
